import React, { Component, Fragment } from "react";
import AssignedCustomersItem from "./AssignedCustomersItem";
import isEmpty from 'lodash/isEmpty';

class AssignedCustomers extends Component{

    constructor(props){
        super(props);
        this.state = {           
            loading: false, 
            currentPage: 1,
            leftIndex: 0,
            rightIndex: 0,
            q: '',
            customersSearched: [],
            totalItems: props.customersList
        }
    }

    componentDidMount(){
        //Set state from a prop
        this.setState({
            loading: true,
        },() => {
            this.setState({
                totalItems: this.props.customersList.length,
                rightIndex: this.props.itemsPerPage,
                loading: false
            })
        }
        )
    }

    prevPage = () => {
        const rightIndex = this.state.leftIndex;
        const leftIndex = this.returnMinLeftIndex(this.state.leftIndex - this.props.itemsPerPage)

        this.setState({
            leftIndex: leftIndex,
            rightIndex: rightIndex,
            currentPage: this.state.currentPage === 1 ? 1 : this.state.currentPage - 1
        })
    }

    nextPage = () => {
        const leftIndex = this.state.rightIndex;
        const rightIndex = this.returnMaxRightIndex(leftIndex + this.props.itemsPerPage);

        this.setState({
            leftIndex: leftIndex,
            rightIndex: rightIndex,
            currentPage: this.state.currentPage + 1
        })
    }

    // Gets the highest right index (based on the max length of array)
    returnMaxRightIndex = (testIndex) => {
        return testIndex > this.state.totalItems ? this.state.totalItems : testIndex;
    }

    // Gets the lowest index, otherwise return 0
    returnMinLeftIndex = (testIndex) => {
        return testIndex < 0 ? 0 : testIndex;
    }

    handleSearch(value){
        this.setState({
            isSearching: true,
            q: value
        }, () => {
            if(isEmpty(value)){
                this.setState({
                    isSearching: false,
                    totalItems: this.props.customersList.length
                });
            } else {
                this.setState({
                    customersSearched: this.props.customersList.filter(item => item.email.toLowerCase().includes(value.toLowerCase()) || item.fname.toLowerCase().includes(value.toLowerCase()) || item.lname.toLowerCase().includes(value.toLowerCase()) )
                } , () => this.setState({totalItems: this.state.customersSearched.length}))
            }
        })
    }

    render(){
        const { customersList, itemsPerPage, loading } = this.props;
        const { currentPage, leftIndex, rightIndex, q, customersSearched, isSearching, totalItems } = this.state;

        let customers = isSearching ? customersSearched : customersList;
        return(
            <div className="customer-search-items">
                {loading ? <Fragment></Fragment> : 
                <Fragment>
                    <div className="customer-search-label">Assigned Customers:</div>
                    {/* Searchbar */}
                    <div className="ajax-search-wrapper" style={{marginBottom: '0.75em'}}>
                        <div className={`input-placeholder-wrapper placeholder--search-field`}>
                            <span className="placeholder icon-search" />
                            <input type="text" value={q} placeholder="Search customers" onChange={e => this.handleSearch(e.target.value)}/>
                        </div>
                    </div>

                    {isEmpty(customers) ? <Fragment>No customers have been added to this top tier.</Fragment>
                    : 
                    <Fragment>
                        {customers.slice(leftIndex, rightIndex).map((item, i) => {
                            return (
                                <AssignedCustomersItem item={item} index={i} key={i} removeCustomer={index => this.props.handleCustomerRemove(index)}/>
                            )
                        })}
                        {totalItems >= itemsPerPage &&
                        <div className="customer-search-items-pagination">
                            <button 
                                disabled={currentPage === 1}
                                onClick={() => this.prevPage()}
                            >
                                <div className="icon-backward"></div>
                                Prev
                            </button>
                            <div className="customer-search-items-pagination-page">{currentPage}</div>
                            <button
                                disabled={rightIndex >= totalItems}
                                onClick={() => this.nextPage()}
                            >
                                Next
                                <div className="icon-forward"></div>
                            </button>
                        </div>
                        }
                    </Fragment>
                    }
                </Fragment>
                }
            </div>
        )
    }
}

export default AssignedCustomers;


// WEBPACK FOOTER //
// ./src/components/admin/top-tiers/customers/AssignedCustomers.js